{{ runChangeDetection }}
<!-- Online -->
<div (deferVizible)="visible($event)" [ngStyle]="{ 'min-height': '100px' }">
  <div class="my-7">
    <carousel *ngIf="isLoaded" [arrows]="arContacts?.length > 4" [height]="90" [cellsToShow]="4">
      <div *ngFor="let client of arContacts; let i = index" class="carousel-cell">
        <div (click)="openDetail(client)" class="pointer position-relative text-reset text-center">
          <app-avatar
            [Service]="Service"
            [id]="client.id"
            [class.avatar-online]="client?.online && !Service.loadHistoryError"
            [type]="'private'"
            [avatar]="client.avatar"
            [avatarFileId]="client.avatar_file_id"
            [avatarFileUniqueId]="client.avatar_file_unique_id"
            [serviceType]="client.service_type"
            class="d-inline-block avatar avatar-sm mb-3"
          >
            <div *ngIf="Service.type === 'all' && client.service_type">
              <img
                loading="lazy"
                class="avatar-type pl-2 invert {{client.service_type}}"
                width="30"
                height="30"
                src="/assets/icons/socials/{{ client.service_type | fixType}}.svg"
              />
            </div>
          </app-avatar>

          <div class="small text-truncate">{{ client?.name?.first }}</div>
        </div>
      </div>
    </carousel>
  </div>
</div>
<!-- Online -->
